/**
 * Action-kind registry.
 *
 * One file per kind, resolved by name — never a switch inside a shared file.
 * Phase 6 adds whatsapp/chat/readmore here with no change to any caller.
 */

import { ACTION_KIND } from '../../model.js';
import * as cart from './cart.js';
import * as explore from './explore.js';
import * as soldout from './soldout.js';
import * as whatsapp from './whatsapp.js';
import * as chat from './chat.js';
import * as readmore from './readmore.js';

const REGISTRY = {
	[ACTION_KIND.CART]: cart,
	[ACTION_KIND.EXPLORE]: explore,
	[ACTION_KIND.SOLDOUT]: soldout,
	[ACTION_KIND.WHATSAPP]: whatsapp,
	[ACTION_KIND.CHAT]: chat,
	[ACTION_KIND.READMORE]: readmore,
};

export function renderAction(model, ctx) {
	// A block can override the kind the adapter derived — "this whole strip is
	// an enquiry placement". A render-time decision, like showPrice, so the
	// model keeps the truth about what the item actually supports.
	const kind = (ctx && ctx.actionKind) || model.actions.kind;
	const impl = REGISTRY[kind];
	// An unimplemented kind renders no actions rather than throwing — a card
	// with no buy button still shows its product; a thrown error shows nothing.
	if (!impl) return null;
	return impl.render(model, ctx);
}

export function hasAction(kind) {
	return Object.prototype.hasOwnProperty.call(REGISTRY, kind);
}
